import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@hulahoop/ui";
import type { ComponentProps } from "react";
import type { CreateInvestmentLabels } from "@/domain/types/investmentPiece";
import { CreateInvestmentFields } from "./CreateInvestmentFields";

export function CreateInvestmentDialog({
  open,
  onOpenChange,
  labels,
  isReady,
  isCreating,
  onCreate,
  ...fields
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  labels: CreateInvestmentLabels;
  isReady: boolean;
  isCreating: boolean;
  onCreate: () => void;
} & Omit<ComponentProps<typeof CreateInvestmentFields>, "labels">) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{labels.title}</DialogTitle>
          <DialogDescription>{labels.description}</DialogDescription>
        </DialogHeader>
        <CreateInvestmentFields {...fields} labels={labels} />
        <DialogFooter>
          <DialogClose render={<Button variant="outline">{labels.cancel}</Button>} />
          <Button disabled={!isReady || isCreating} onClick={onCreate}>
            {isCreating ? labels.creating : labels.create}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
